import AgentInstructions from "pages/Admin/Agents/AgentInstructions";

export default function AgentInstructionsPage() {
  return <AgentInstructions />;
}
